export default __webpack_public_path__ + "static/media/jikita.b43f10f5.png";